function addPixelUnitToNumber(number) {
  if (Number.isNaN(Number(number))) {
    return number
  }

  return `${number}px`
}

export default addPixelUnitToNumber
